import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

import { NAVIGATION_SIDEBAR_WIDTH } from "app/pages/activation/constants/styles";

export const Container = styled(FlexColumn)`
    width: 100%;
    gap: 16px;
    box-sizing: border-box;
    border-bottom: 1px solid ${colorsPalettes.carbon[100]};
    padding: 24px 44px 16px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 44px);

    @media (min-width: 1920px) {
        padding: 24px 120px 16px calc(${NAVIGATION_SIDEBAR_WIDTH}px + 120px);
    }

    & .rounded {
        border-radius: 50%;
    }

    & .icon {
        border-radius: 4px;
    }

    & .roundedButton {
        border-radius: 18px;
    }
`;

Container.displayName = "Container";

export const Section = styled(FlexRow)`
    width: 100%;
    align-items: center;
    justify-content: space-between;
`;

Section.displayName = "Section";

export const SubSection = styled(FlexRow)`
    align-items: center;
    gap: 16px;
`;
